/**
 * Centralized site-chrome constants: nav links + CTA targets/labels.
 */

/**
 * Primary site nav links, shared by the nav bar. Kept conversion-focused:
 * FAQ is intentionally footer-only (SiteFooter) — it's a support link, and the
 * home already teases it via the MegaSeo "Частые вопросы" block.
 */
export const SITE_NAV_LINKS = [
  { to: '/rasklady', label: 'Расклады' },
  { to: '/ceny', label: 'Цены' },
] as const;

/** The public site's origin (canonical URLs, marketing links to site pages). */
export const SITE_URL = 'https://tarotmeow.ru';

/** The auth gate. Single source of truth for the login destination. */
export const LOGIN_TO = '/login';

/**
 * The bare bot link, for deep links that carry their own start payload (card pages).
 * Sourced from VITE_BOT_URL so each env points at its own bot; the prod bot is
 * the build-time fallback for when the var is unset.
 */
export const TELEGRAM_BOT_BASE_URL = import.meta.env.VITE_BOT_URL ?? 'https://t.me/TarotMeowBot';

/**
 * Telegram bot deep link (footer + secondary "via Telegram" CTAs). `start=site` makes the
 * site the acquisition source of whoever starts the bot from here (docs/marketing/attribution.md).
 * If the visitor landed with `?utm_source=<code>`, siteAttribution.ts swaps `site` (and card
 * pages' `card_<slug>`) for that code at click time, so the channel keeps the credit.
 */
export const TELEGRAM_BOT_URL = `${TELEGRAM_BOT_BASE_URL}?start=site`;

/**
 * Where the marketing "open the app" CTA points — today the auth gate.
 * Repoint to a future anonymous-onboarding route to redirect all CTAs at once.
 */
export const APP_CTA_TO = LOGIN_TO;

/** Primary CTA label — the core action (ask a question), benefit-led over a generic "open app". */
export const APP_CTA_LABEL = 'Задать свой вопрос';

/** Secondary CTA label — continue via the Telegram bot. */
export const TELEGRAM_CTA_LABEL = 'Через Telegram';
